import { useTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';

import JurisdictionChoroplethGraph from './jurisdiction-choropleth';
import { getNivoChartTheme } from '../../assessment/helper';

import * as GQL from '~/graphql/generated/client';

const JurisdictionChoroplethWrapper: React.FC = () => {
  const theme = useTheme();
  const chartTheme = useMemo(() => getNivoChartTheme(theme), [theme]);

  const { data: jurisdictionData } = GQL.useJurisdictionChoroplethDataQuery({
    fetchPolicy: 'network-only',
  });

  const { data: projectJurisdictionData } =
    GQL.useProjectJurisdictionChoroplethDataQuery({
      fetchPolicy: 'network-only',
    });

  return (
    <JurisdictionChoroplethGraph
      title="Policy Coverage by Jurisdiction"
      subHeader="Number of policies available per country/region"
      jurisdictionData={jurisdictionData?.jurisdictionChoroplethData}
      projectJurisdictionData={
        projectJurisdictionData?.projectJurisdictionChoroplethData
      }
      chartTheme={chartTheme}
    />
  );
};

export default JurisdictionChoroplethWrapper;
